import * as React from 'react';

import { config } from '../../../browser/config';
import { IService } from '../../models/service';
import { SmsForm } from '../service_mobile/sms_form';
import { StoreLink } from '../service_mobile/store_link';

const s = require('./service_block_bottom.css');

interface IProps {
  onAdsClick(eventLabel: string): void;
  onPremClick(eventLabel: string): void;
  service: IService;
  onSendSMS: (phone: string) => void;
  onResendSMS: () => void;
}

export const ServiceBlockBottom = (props: IProps) =>
  <div className={`${s['c-services-bottom']}`}>
    <div className="cg-container-fluid-xs">
      <div className="cg-row">
        <div className={`cg-skip-1 cg-skip-xs-0 cg-col-4`}>
          <div className={s['c-sms-form-image']} />
        </div>
        <div className="cg-col-11">
          <SmsForm {...props} />
        </div>
        <div className="cg-col-8">
          <StoreLink
              onClick={() => props.onAdsClick('mob_app_AS')}
              store="apple"
              url={config.storesUrls.apple} />
          <StoreLink
              onClick={() => props.onAdsClick('mob_app_GP')}
              store="google"
              url={config.storesUrls.google} />
        </div>
      </div>
    </div>
  </div>;
